import { PocCard } from 'commons/components/components-wrapper/poc-card.component';
import { PocProgressSpinner } from 'commons/components/components-wrapper/poc-progress-spinner.component';
import { PocTypography } from 'commons/components/components-wrapper/poc-typography.component';
import { AddButton } from 'commons/components';
import { useTranslation } from 'core/i18n/i18n';
import { SettingsLoadingContainer } from 'modules/settings/settings.style';
import { AutomationRulesDropdown } from '../components/automation-rules-dropdown.component';
import { TriggerOptionItem } from '../components/trigger-option-item.component';
import { AutomationRulesDataKeys } from '../constants/backend-enums';
import { OnChangeStateTypeValues, TriggerActionsState } from '../constants/frontend-enums';
import { AutomationRuleOption, OnAddOptionHandlerProps } from '../hooks/use-automation-rule-options-state';
import { AutomationRulesCardLayout, FieldsContainer } from '../styled/automation-rules.style';
import { DeleteOptionParams, ExternalOptions, OnChangeAutomationRuleStateData } from '../types/automation-rules.type';

interface TriggerLayoutProps {
    conditionOptions: AutomationRuleOption[];
    isLoading: boolean;
    whenTriggerOptions: ExternalOptions[];
    defaultWhenTrigger: ExternalOptions;
    externalOptions: ExternalOptions[];
    onAddActionHandler: (data: OnAddOptionHandlerProps) => () => void;
    onDeleteOptionHandler: (data: DeleteOptionParams) => () => void;
    onChange: (data: OnChangeAutomationRuleStateData) => void;
}

export const TriggerLayout = (props: TriggerLayoutProps) => {
    const {
        conditionOptions,
        isLoading,
        whenTriggerOptions,
        defaultWhenTrigger,
        externalOptions,
        onAddActionHandler,
        onDeleteOptionHandler,
        onChange,
    } = props;

    const { t } = useTranslation();
    const conditionOptionsLength = conditionOptions.length;

    return (
        <PocCard rounded>
            <AutomationRulesCardLayout className="col-dir">
                {isLoading ? (
                    <SettingsLoadingContainer>
                        <PocProgressSpinner variant="primary" size="large" />
                    </SettingsLoadingContainer>
                ) : (
                    <>
                        <PocCard>
                            <AutomationRulesCardLayout className="alg-itm-ctr">
                                <PocTypography variant="subtitle2">
                                    {t('settings.system.automation-rules.logical-operators.when')}
                                </PocTypography>
                                <FieldsContainer>
                                    <AutomationRulesDropdown
                                        name={AutomationRulesDataKeys.trigger}
                                        options={whenTriggerOptions}
                                        defaultSelectedOption={defaultWhenTrigger.id}
                                        type={OnChangeStateTypeValues.input}
                                        onChange={onChange}
                                        disabled
                                    />
                                </FieldsContainer>
                            </AutomationRulesCardLayout>
                        </PocCard>
                        <AutomationRulesCardLayout className="col-dir" padding="16px 0 10px 32px">
                            {conditionOptionsLength > 0 && (
                                <PocTypography variant="subtitle2">
                                    {t('settings.system.automation-rules.details.conditions')}
                                </PocTypography>
                            )}
                            {conditionOptions?.map((el, index) => {
                                const { content, id } = el;
                                return (
                                    <TriggerOptionItem
                                        key={el.id}
                                        content={content}
                                        id={id}
                                        index={index}
                                        externalOptions={externalOptions}
                                        onDeleteOptionHandler={onDeleteOptionHandler}
                                    />
                                );
                            })}
                            <AddButton
                                text={t('settings.system.automation-rules.logical-operators.add-condition')}
                                onClick={onAddActionHandler({ parentArrayName: TriggerActionsState.conditions })}
                            />
                        </AutomationRulesCardLayout>
                    </>
                )}
            </AutomationRulesCardLayout>
        </PocCard>
    );
};
